import { makeModuleStateSelector } from "@client/content/selectors";
import {
  type SettingsPropsParametricSelector,
  TargetSelector,
  getColorSelector,
  makeBorderStyleSelector
} from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type MemberWallet } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberWallet.AppState>(defaultState, previewState);

export const makeItemsSelector = () => {
  return createSelector([localStateSelector], (localState) => localState.accounts);
};

export const makeAccountDetailSelector = () => {
  return createSelector(
    [localStateSelector],
    (localState) => localState.accounts.find((x) => x.accountId === localState.showingAccountDetailId) ?? null
  );
};

export const makeAccountStyleSelector = (): SettingsPropsParametricSelector => {
  const backgroundColorSelector = getColorSelector(TargetSelector.Entity, "backgroundColor", "item");

  const borderStyleSelector = makeBorderStyleSelector(TargetSelector.Entity, "item");

  return createSelector(
    [backgroundColorSelector, borderStyleSelector],
    (backgroundColor, borderStyle): React.CSSProperties => ({
      ...borderStyle,
      backgroundColor
    })
  );
};
